import {ButtonProps, Buttons} from '@esgillc/ui-kit/button';
import {join} from '@esgillc/ui-kit/utils';
import {forwardRef} from 'react';
import styles from './styles.module.less';

export const IconButton = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
	return <Buttons.Icon {...props} className={join(props.className, styles.iconButton)} ref={ref}/>;
});
